import * as React from "react";
import { CorrectionItem } from "../CorrectionItem";

export const RecordingStartItem = ({ recordId, isDisabled, onClick, onRemove, correctionSelected }): JSX.Element => {
    return (
        <CorrectionItem
                recordId={recordId}
                title="Change Recording Start"
                description="Change the recording start date and time"
                isDisabled={isDisabled}
                onClick={onClick}
                onRemove={onRemove}
                correctionSelected={correctionSelected}
            />
    );
}
